export default function PHP_StudyPlan() {
  return (
    <div>
      <h1>PHP_StudyPlan</h1>
    </div>
  );
}
